module.exports = require("@ngx-lite/json-ld");